import { useQuery } from '@tanstack/react-query';

import { competitorsApi } from './api';

export const useSearchCompetitorsQuery = (searchTerm: string) => {
  return useQuery({
    queryKey: ['websiteSearch', searchTerm],
    queryFn: () => competitorsApi.searchCompetitors(searchTerm),
    enabled: !!searchTerm,
  });
};
